import type { PortableTextBlock } from '@portabletext/types'

interface Module {
  _type: string
  _key: string
  title?: string
  skipLinkTitle?: string
  omitSkipLink?: boolean
  isSkipLinkChild?: boolean
  moduleId?: string
  body?: PortableTextBlock[]
}

export interface SkipLinkItem {
  title: string
  link: string
  children?: SkipLinkItem[]
}

type GenerateSkipLinks = (
  modules: Module[] | undefined,
  useTitle?: boolean
) => SkipLinkItem[]

type IsEligibleModule = (module: Module) => boolean
type CreateSkipLinkItem = (module: Module) => SkipLinkItem

const isEligibleModule: IsEligibleModule = module => {
  const eligibleTypes = ['pageTextBlock', 'textBlock', 'numberBlock']
  return (
    eligibleTypes.includes(module._type) &&
    (!!module.title || !!module.skipLinkTitle) &&
    module.omitSkipLink !== true
  )
}

const createSkipLinkItem: CreateSkipLinkItem = module => ({
  title: module.skipLinkTitle || module.title || '',
  link: module.moduleId || module._key,
})

const generateSkipLinks: GenerateSkipLinks = (modules, useTitle = false) => {
  const skipLinks: SkipLinkItem[] = []
  let lastNonChildItem: SkipLinkItem | null = null

  modules?.filter(isEligibleModule).forEach(module => {
    const newItem = createSkipLinkItem(module)

    if (!module.isSkipLinkChild) {
      newItem.children = []
      skipLinks.push(newItem)
      lastNonChildItem = newItem

      // Check for h3 elements in the body only if it's not a skip link child
      if (
        module.body &&
        ['pageTextBlock', 'textBlock', 'numberBlock'].includes(module._type) &&
        module.omitSkipLink !== true
      ) {
        if (!useTitle) {
          module.body.forEach(block => {
            if (block.style === 'h3' && block.children && block.children[0]) {
              const h3Item: SkipLinkItem = {
                title: block.children[0].text || '',
                link: block._key || '',
              }
              if (lastNonChildItem && lastNonChildItem.children) {
                lastNonChildItem.children.push(h3Item)
              }
            }
          })
        }
      }
    } else if (lastNonChildItem && lastNonChildItem.children) {
      lastNonChildItem.children.push(newItem)
    }
  })

  return skipLinks
}

export default generateSkipLinks
